import React, { useState } from 'react';
import { Modal, Input, message } from 'antd';
import "./InputTextDlgWidget.css"
import { confirmable } from 'react-confirm';

const InputTextDlgWidget = (props) => {
    const { show, proceed, title, okText, cancelText } = props;
    const [password, setPassword] = useState("");

    return (
        <Modal
            open={true}
            destroyOnClose={true}
            onCancel={async () => {
                proceed("");
            }}
            closable={true}
            maskClosable={false}
            className="confirm-modal"
            title={title}
            okText={"OK"}
            cancelText={"Cancel"}
            onOk={async () => {
                if (password === "") {
                    message.error("Please Enter Password");
                    return;
                }
                proceed(password);
            }}>
            <div style={{ marginTop: 20 }}>
                <Input.Password
                    placeholder={"Password"}
                    onPressEnter={(e) => {
                        setPassword(e.target.value)
                    }
                    }
                    value={password}
                    onChange={(e) =>
                        setPassword(e.target.value)
                    }
                />
            </div>
        </Modal>
    );
};

export default confirmable(InputTextDlgWidget);